import BuyCourseActionTypes from './buyCourse.types';
import { initialBuyCourseState } from '../initialState';

export const buyCourse = (state = initialBuyCourseState, action = {}) => {
	switch (action.type) {
		case BuyCourseActionTypes.FETCH_PRODUCT_LIST.SUCCESS:
			return Object.assign({}, state, { productList: action.payload });
		case BuyCourseActionTypes.SET_CURRENT_PRODUCT_ID:
			return Object.assign({}, state, { currentProductId: action.payload });
		case BuyCourseActionTypes.FETCH_PRODUCT_DETAILS.SUCCESS:
			return Object.assign({}, state, { productData: { ...action.payload } });
		case BuyCourseActionTypes.VALIDATE_COUPON.SUCCESS:
			return Object.assign({}, state, { ...action.payload });
		case BuyCourseActionTypes.VALIDATE_COUPON.FAILURE:
			return Object.assign({}, state, { ...action.payload });
		case BuyCourseActionTypes.SET_COUPON:
			return Object.assign({}, state, { couponCode: action.payload });
		case BuyCourseActionTypes.SET_API_COUNT:
			return Object.assign({}, state, { apiCount: action.payload });
		case BuyCourseActionTypes.START_TRANSACTION.SUCCESS:
			return Object.assign({}, state, { ...action.payload });
		case BuyCourseActionTypes.PROCESS_PAYMENT.SUCCESS ||
			BuyCourseActionTypes.PROCESS_PAYMENT.FAILURE:
			return Object.assign({}, state, { paymentStatus: action.payload });
		case BuyCourseActionTypes.RESET_CHECKSUM:
			return Object.assign({}, state, { checkSum: '' });
		case BuyCourseActionTypes.SET_PAY_METHOD:
			return Object.assign({}, state, { payment_type: action.payload });
		case BuyCourseActionTypes.SHOW_PREVIEW_COURSES:
			return Object.assign({}, state, { showPreviewCourses: action.payload });
		case BuyCourseActionTypes.FETCH_RELATED_PRODUCTS.SUCCESS:
			return Object.assign({}, state, { relatedProductsList: action.payload });
		default:
			return state;
	}
};
